export enum CaptureMethod {
  Cashier = 1 << 0,
  QRCode = 1 << 1
}